import { useFeature } from 'hooks/useFeature';
import NotFoundPage from 'pages/404';
import ReturnsPage from 'ui/pages/ReturnsPage';

const Returns = () => {
  const returnsPageDisabled = useFeature('RETURNS_PAGE_DISABLED');
  if (returnsPageDisabled) {
    return <NotFoundPage />;
  }

  return <ReturnsPage />;
};
export default Returns;
